(function () {
  var carouselMap = new WeakMap();
  var resizeTimer;

  function isDesktop() {
    return window.innerWidth >= 768;
  }

  function updateColumns(el) {
    var raw = isDesktop()
      ? el.dataset.columnsDesktop
      : el.dataset.columnsMobile;
    var cols = parseFloat(raw);

    if (!cols || cols <= 0) {
      cols = isDesktop() ? 5 : 2.4;
    }

    el.style.setProperty('--fc-columns', cols);
  }

  function getOptions(el) {
    var desktop = isDesktop();
    var mobileScroll = el.dataset.mobileScroll === 'true';

    return {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: desktop,
      draggable: true,
      freeScroll: !desktop && mobileScroll,
      wrapAround: false,
      selectedAttraction: desktop ? 0.04 : 0.025,
      friction: desktop ? 1 : 0.25,
    };
  }

  function initCarousel(el) {
    if (typeof Flickity === 'undefined') return null;

    var existing = Flickity.data(el);

    if (existing) {
      updateColumns(el);
      existing.resize();
      return existing;
    }

    updateColumns(el);

    var flkty = new Flickity(el, getOptions(el));
    carouselMap.set(el, flkty);
    return flkty;
  }

  function initCarouselsIn(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fc-carousel]').forEach(initCarousel);
  }

  function destroyCarousel(el) {
    var flkty = carouselMap.get(el) || Flickity.data(el);
    if (flkty) {
      flkty.destroy();
      carouselMap.delete(el);
    }
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-fc-carousel]').forEach(function (el) {
        var flkty = Flickity.data(el);
        updateColumns(el);
        if (flkty) {
          flkty.resize();
        }
      });
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCarouselsIn();
    });
  } else {
    initCarouselsIn();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    initCarouselsIn(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-fc-carousel]').forEach(destroyCarousel);
  });
})();
